// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"621":"3307a1cf","743":"c0756ec1","917":"15472852"}[chunkId] + ".chunk.js";
};